<app-pt-navbar></app-pt-navbar>
<div class="portal-page">
  <router-outlet></router-outlet>
</div>
<app-pt-footer></app-pt-footer>
